import { z } from 'zod';

/** Prospect Service contact endpoint (`POST {baseUrl}/v1/contact`). */
export const PROSPECT_CONTACT_PATH = '/v1/contact';

/** Mirrors prospect-service `ContactLocationDto`. */
export const contactLocationSchema = z.object({
  postalCode: z.string(),
  country: z.string(),
  ipInferredPostalCode: z.string(),
});

/** Mirrors prospect-service `ContactDetailsDto` (whitelist fields only). */
export const contactDetailsSchema = z
  .object({
    lastName: z.string().optional(),
    email: z.string().optional(),
    phoneNumber: z.string().optional(),
    location: contactLocationSchema.optional(),
    hsGradYear: z.number().optional(),
    levelOfEducation: z.string().optional(),
    militaryStatus: z.boolean().optional(),
    startDate: z.string().optional(),
    tcpaText: z.string().optional(),
    thirdPartyLeadId: z.string().optional(),
    currentLicense: z.string().nullable().optional(),
    hasGivenTCPAConsent: z.boolean().optional(),
    hasGivenThirdPartySharingConsent: z.boolean().optional(),
    hasGivenProspectSharingConsent: z.boolean().optional(),
    currentPermanentResidenceCountry: z.string().optional(),
    leadSource: z.string().nullable().optional(),
    category: z.string().nullable().optional(),
    degree: z.string().nullable().optional(),
    subject: z.string().nullable().optional(),
  })
  .strict();

export type ContactDetails = z.infer<typeof contactDetailsSchema>;

export const contactSaveRequestSchema = z.object({
  contact: z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phoneNumber: z.string(),
    zip: z.string(),
    details: contactDetailsSchema.optional(),
    trackingContext: z.record(z.unknown()).optional(),
  }),
});

export type ContactSaveRequest = z.infer<typeof contactSaveRequestSchema>;

export const contactResponseSchema = z.object({
  data: z.object({
    contactId: z.string(),
    transactionId: z.number(),
    retrievalUrl: z.string(),
  }),
});

export type ContactSaveResponse = z.infer<typeof contactResponseSchema>;

/** @deprecated Use `ContactSaveRequest` */
export type ContactReqPayload = ContactSaveRequest;
